<template>
    <div class="page-seoGame" :style="{ 'background-image': 'url(' + backgroundImage + ')' }">
        <v-container>
            <div class="page-seoGame__container">

                <div class="page-seoGame__header">
                    <div class="logoGame">
                        <picture>
                            <source :srcset="game.bigCoverImage && game.bigCoverImage.webp" type="image/webp">
                            <img ref="image" :src="game.bigCoverImage && game.bigCoverImage.jpg" :alt="game.title"/>
                        </picture>
                    </div>
                    <div class="inf">
                        <div class="inf-text">
                            <h1>{{ game.title }}</h1>
                            <p>{{ game.platformTitle }}</p>
                        </div>
                        <div class="inf-buttons">
                            <router-link :to="gamePlayFunUrl" class="btn-free" v-if="isPlayForFunAllowed" event=""
                                         @click.native.prevent="playForFun">
                                {{ $t('front.game.button.play_free') }}
                            </router-link>

                            <router-link :to="gamePlayRealUrl" class="btn-play" v-if="game.playForReal" event=""
                                         @click.native.prevent="playForReal">
                                {{ $t('front.game.button.play_real') }}
                            </router-link>
                        </div>
                    </div>
                </div>

                <div class="page-seoGame__content">
                    <p>
              <span class="box-info">
                <span class="box-info__rate">
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip1)">
                    <path
                        d="M0.724854 6.8204C0.777045 6.68983 0.816189 6.55925 0.881428 6.44173C1.10324 6.02389 1.48163 5.85414 1.92526 5.78885C3.29529 5.57993 4.67837 5.37101 6.0484 5.16209C6.28326 5.12292 6.43984 5.01846 6.54422 4.79648C7.15747 3.4646 7.77072 2.14579 8.39702 0.826973C8.73627 0.108806 9.48 -0.152346 10.1454 0.213267C10.4194 0.3569 10.576 0.604994 10.6935 0.866146C11.2937 2.15885 11.9069 3.45155 12.4941 4.74425C12.6115 5.0054 12.7811 5.13597 13.0682 5.17515C14.4643 5.38407 15.8604 5.59299 17.2566 5.81497C17.7654 5.89331 18.1177 6.16752 18.2612 6.66371C18.4178 7.14684 18.2873 7.56469 17.935 7.9303C16.9173 8.9749 15.9126 10.0195 14.8818 11.0641C14.647 11.2992 14.5817 11.5211 14.6339 11.8476C14.8818 13.3231 15.1297 14.7986 15.3516 16.2741C15.4559 16.927 15.0906 17.4623 14.4643 17.6451C14.4382 17.6582 14.4121 17.6713 14.386 17.6843C14.2425 17.6843 14.0859 17.6843 13.9424 17.6843C13.7858 17.619 13.6162 17.5668 13.4727 17.4754C12.2592 16.8095 11.0458 16.1435 9.84534 15.4645C9.61048 15.3339 9.41476 15.3339 9.1799 15.4645C7.82292 16.2088 6.46593 16.9531 5.10895 17.6843C4.95238 17.6843 4.78275 17.6843 4.62618 17.6843C4.61313 17.6713 4.58703 17.6582 4.56094 17.6582C3.90854 17.4754 3.55625 16.94 3.64759 16.2741C3.88245 14.7464 4.13036 13.2056 4.39132 11.6778C4.43046 11.482 4.37827 11.3253 4.23474 11.1816C3.25615 10.1762 2.2906 9.17077 1.31201 8.17839C1.07715 7.87807 0.816189 7.61692 0.724854 7.22519C0.724854 7.09461 0.724854 6.95098 0.724854 6.8204Z"
                        fill="#FBC763"/>
                    </g>
                    <defs>
                    <clipPath id="clip1">
                    <rect width="17.6147" height="17.6147" fill="white" transform="translate(0.724854 0.0449219)"/>
                    </clipPath>
                    </defs>
                  </svg>
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip2)">
                    <path
                        d="M0.724854 6.8204C0.777045 6.68983 0.816189 6.55925 0.881428 6.44173C1.10324 6.02389 1.48163 5.85414 1.92526 5.78885C3.29529 5.57993 4.67837 5.37101 6.0484 5.16209C6.28326 5.12292 6.43984 5.01846 6.54422 4.79648C7.15747 3.4646 7.77072 2.14579 8.39702 0.826973C8.73627 0.108806 9.48 -0.152346 10.1454 0.213267C10.4194 0.3569 10.576 0.604994 10.6935 0.866146C11.2937 2.15885 11.9069 3.45155 12.4941 4.74425C12.6115 5.0054 12.7811 5.13597 13.0682 5.17515C14.4643 5.38407 15.8604 5.59299 17.2566 5.81497C17.7654 5.89331 18.1177 6.16752 18.2612 6.66371C18.4178 7.14684 18.2873 7.56469 17.935 7.9303C16.9173 8.9749 15.9126 10.0195 14.8818 11.0641C14.647 11.2992 14.5817 11.5211 14.6339 11.8476C14.8818 13.3231 15.1297 14.7986 15.3516 16.2741C15.4559 16.927 15.0906 17.4623 14.4643 17.6451C14.4382 17.6582 14.4121 17.6713 14.386 17.6843C14.2425 17.6843 14.0859 17.6843 13.9424 17.6843C13.7858 17.619 13.6162 17.5668 13.4727 17.4754C12.2592 16.8095 11.0458 16.1435 9.84534 15.4645C9.61048 15.3339 9.41476 15.3339 9.1799 15.4645C7.82292 16.2088 6.46593 16.9531 5.10895 17.6843C4.95238 17.6843 4.78275 17.6843 4.62618 17.6843C4.61313 17.6713 4.58703 17.6582 4.56094 17.6582C3.90854 17.4754 3.55625 16.94 3.64759 16.2741C3.88245 14.7464 4.13036 13.2056 4.39132 11.6778C4.43046 11.482 4.37827 11.3253 4.23474 11.1816C3.25615 10.1762 2.2906 9.17077 1.31201 8.17839C1.07715 7.87807 0.816189 7.61692 0.724854 7.22519C0.724854 7.09461 0.724854 6.95098 0.724854 6.8204Z"
                        fill="#FBC763"/>
                    </g>
                    <defs>
                    <clipPath id="clip2">
                    <rect width="17.6147" height="17.6147" fill="white" transform="translate(0.724854 0.0449219)"/>
                    </clipPath>
                    </defs>
                  </svg>
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip3)">
                    <path
                        d="M0.724854 6.8204C0.777045 6.68983 0.816189 6.55925 0.881428 6.44173C1.10324 6.02389 1.48163 5.85414 1.92526 5.78885C3.29529 5.57993 4.67837 5.37101 6.0484 5.16209C6.28326 5.12292 6.43984 5.01846 6.54422 4.79648C7.15747 3.4646 7.77072 2.14579 8.39702 0.826973C8.73627 0.108806 9.48 -0.152346 10.1454 0.213267C10.4194 0.3569 10.576 0.604994 10.6935 0.866146C11.2937 2.15885 11.9069 3.45155 12.4941 4.74425C12.6115 5.0054 12.7811 5.13597 13.0682 5.17515C14.4643 5.38407 15.8604 5.59299 17.2566 5.81497C17.7654 5.89331 18.1177 6.16752 18.2612 6.66371C18.4178 7.14684 18.2873 7.56469 17.935 7.9303C16.9173 8.9749 15.9126 10.0195 14.8818 11.0641C14.647 11.2992 14.5817 11.5211 14.6339 11.8476C14.8818 13.3231 15.1297 14.7986 15.3516 16.2741C15.4559 16.927 15.0906 17.4623 14.4643 17.6451C14.4382 17.6582 14.4121 17.6713 14.386 17.6843C14.2425 17.6843 14.0859 17.6843 13.9424 17.6843C13.7858 17.619 13.6162 17.5668 13.4727 17.4754C12.2592 16.8095 11.0458 16.1435 9.84534 15.4645C9.61048 15.3339 9.41476 15.3339 9.1799 15.4645C7.82292 16.2088 6.46593 16.9531 5.10895 17.6843C4.95238 17.6843 4.78275 17.6843 4.62618 17.6843C4.61313 17.6713 4.58703 17.6582 4.56094 17.6582C3.90854 17.4754 3.55625 16.94 3.64759 16.2741C3.88245 14.7464 4.13036 13.2056 4.39132 11.6778C4.43046 11.482 4.37827 11.3253 4.23474 11.1816C3.25615 10.1762 2.2906 9.17077 1.31201 8.17839C1.07715 7.87807 0.816189 7.61692 0.724854 7.22519C0.724854 7.09461 0.724854 6.95098 0.724854 6.8204Z"
                        fill="#FBC763"/>
                    </g>
                    <defs>
                    <clipPath id="clip3">
                    <rect width="17.6147" height="17.6147" fill="white" transform="translate(0.724854 0.0449219)"/>
                    </clipPath>
                    </defs>
                  </svg>
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip4)">
                    <path
                        d="M0.724854 6.8204C0.777045 6.68983 0.816189 6.55925 0.881428 6.44173C1.10324 6.02389 1.48163 5.85414 1.92526 5.78885C3.29529 5.57993 4.67837 5.37101 6.0484 5.16209C6.28326 5.12292 6.43984 5.01846 6.54422 4.79648C7.15747 3.4646 7.77072 2.14579 8.39702 0.826973C8.73627 0.108806 9.48 -0.152346 10.1454 0.213267C10.4194 0.3569 10.576 0.604994 10.6935 0.866146C11.2937 2.15885 11.9069 3.45155 12.4941 4.74425C12.6115 5.0054 12.7811 5.13597 13.0682 5.17515C14.4643 5.38407 15.8604 5.59299 17.2566 5.81497C17.7654 5.89331 18.1177 6.16752 18.2612 6.66371C18.4178 7.14684 18.2873 7.56469 17.935 7.9303C16.9173 8.9749 15.9126 10.0195 14.8818 11.0641C14.647 11.2992 14.5817 11.5211 14.6339 11.8476C14.8818 13.3231 15.1297 14.7986 15.3516 16.2741C15.4559 16.927 15.0906 17.4623 14.4643 17.6451C14.4382 17.6582 14.4121 17.6713 14.386 17.6843C14.2425 17.6843 14.0859 17.6843 13.9424 17.6843C13.7858 17.619 13.6162 17.5668 13.4727 17.4754C12.2592 16.8095 11.0458 16.1435 9.84534 15.4645C9.61048 15.3339 9.41476 15.3339 9.1799 15.4645C7.82292 16.2088 6.46593 16.9531 5.10895 17.6843C4.95238 17.6843 4.78275 17.6843 4.62618 17.6843C4.61313 17.6713 4.58703 17.6582 4.56094 17.6582C3.90854 17.4754 3.55625 16.94 3.64759 16.2741C3.88245 14.7464 4.13036 13.2056 4.39132 11.6778C4.43046 11.482 4.37827 11.3253 4.23474 11.1816C3.25615 10.1762 2.2906 9.17077 1.31201 8.17839C1.07715 7.87807 0.816189 7.61692 0.724854 7.22519C0.724854 7.09461 0.724854 6.95098 0.724854 6.8204Z"
                        fill="#FBC763"/>
                    </g>
                    <defs>
                    <clipPath id="clip4">
                    <rect width="17.6147" height="17.6147" fill="white" transform="translate(0.724854 0.0449219)"/>
                    </clipPath>
                    </defs>
                  </svg>
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip5)">
                    <path
                        d="M0.724854 6.8204C0.777045 6.68983 0.816189 6.55925 0.881428 6.44173C1.10324 6.02389 1.48163 5.85414 1.92526 5.78885C3.29529 5.57993 4.67837 5.37101 6.0484 5.16209C6.28326 5.12292 6.43984 5.01846 6.54422 4.79648C7.15747 3.4646 7.77072 2.14579 8.39702 0.826973C8.73627 0.108806 9.48 -0.152346 10.1454 0.213267C10.4194 0.3569 10.576 0.604994 10.6935 0.866146C11.2937 2.15885 11.9069 3.45155 12.4941 4.74425C12.6115 5.0054 12.7811 5.13597 13.0682 5.17515C14.4643 5.38407 15.8604 5.59299 17.2566 5.81497C17.7654 5.89331 18.1177 6.16752 18.2612 6.66371C18.4178 7.14684 18.2873 7.56469 17.935 7.9303C16.9173 8.9749 15.9126 10.0195 14.8818 11.0641C14.647 11.2992 14.5817 11.5211 14.6339 11.8476C14.8818 13.3231 15.1297 14.7986 15.3516 16.2741C15.4559 16.927 15.0906 17.4623 14.4643 17.6451C14.4382 17.6582 14.4121 17.6713 14.386 17.6843C14.2425 17.6843 14.0859 17.6843 13.9424 17.6843C13.7858 17.619 13.6162 17.5668 13.4727 17.4754C12.2592 16.8095 11.0458 16.1435 9.84534 15.4645C9.61048 15.3339 9.41476 15.3339 9.1799 15.4645C7.82292 16.2088 6.46593 16.9531 5.10895 17.6843C4.95238 17.6843 4.78275 17.6843 4.62618 17.6843C4.61313 17.6713 4.58703 17.6582 4.56094 17.6582C3.90854 17.4754 3.55625 16.94 3.64759 16.2741C3.88245 14.7464 4.13036 13.2056 4.39132 11.6778C4.43046 11.482 4.37827 11.3253 4.23474 11.1816C3.25615 10.1762 2.2906 9.17077 1.31201 8.17839C1.07715 7.87807 0.816189 7.61692 0.724854 7.22519C0.724854 7.09461 0.724854 6.95098 0.724854 6.8204Z"
                        fill="#FBC763"/>
                    </g>
                    <defs>
                    <clipPath id="clip5">
                    <rect width="17.6147" height="17.6147" fill="white" transform="translate(0.724854 0.0449219)"/>
                    </clipPath>
                    </defs>
                  </svg>
                </span>
                <img :src="logotypePath" :alt="appName">
                <span class="box-info__desc">
                  <span class="text">{{ $t('front.game.info.review') }}</span>
                  <span class="date">
                    <span class="date-start">{{ $t('front.game.info.created') }} {{ createdAt }}</span>
                    <span class="date-update">{{ $t('front.game.info.updated') }} {{ updatedAt }}</span>
                  </span>
                </span>
              </span>
                        <span v-html="game.description"></span>
                    </p>
                </div>
            </div>

            <div class="related-games" v-if="relatedGames.length">
                <h2>{{ $t('front.game.titles.related_games') }}</h2>
                <swiper ref="swiperSS" v-bind="settings" :options="settings">
                    <swiper-slide v-for="(item, index) in relatedGames" :key="index">
                        <game-item :item="item" class="listGame__list-item"/>
                    </swiper-slide>
                </swiper>
                <div id="button-next-relacionados" class="swiper-button-next swiper-button-white"
                     @click="swiperNext()"></div>
                <div id="button-prev-relacionados" class="swiper-button-prev swiper-button-white"
                     @click="swiperPrev()"></div>

            </div>
        </v-container>

        <script v-html="jsonLdReviewType" type="application/ld+json"/>
    </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import {brandName, appName} from "../../../../../config/app";
import {
    canPlayFun,
    gamePlayFunUrl,
    gamePlayRealUrl,
    launchGameForFun,
    launchGameForReal
} from "../../../../util/game/launchGameManager";
import {fetchLobbyRecommendedGames} from "../../../../api";
import apiData from "../../../../mixins/apiData";

export default {
    name: "GameItemContent",

    mixins: [apiData],

    components: {
        Swiper,
        SwiperSlide,
    },

    data: function () {
        return {
            relatedGames: [],
            settings: {
                loop: true,
                loopedSlides: 2, // looped slides should be the same
                slidesPerView: 2,
                spaceBetween: 16,
                speed: 500,
                breakpoints: {
                    550: {
                        slidesPerView: 3,
                        spaceBetween: 9
                    },
                    1024: {
                        slidesPerView: 5,
                        spaceBetween: 9
                    }
                },
                navigation: {
                    nextEl: '#button-next-relacionados',
                    prevEl: '#button-prev-relacionados',
                },
            },
        };
    },

    serverPrefetch() {
        return this.getRelatedGames();
    },

    mounted() {
        this.getRelatedGames();
    },

    metaInfo() {
        return this.game.metaInfo;
    },

    computed: {
        jsonLdReviewType() {
            return {
                "@context": "https://schema.org",
                "@type": "Review",
                "itemReviewed": {
                    "@type": "Game",
                    "name": this.game.title,
                    "image": this.game.bigCoverImage.webp
                },
                "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": this.page.rating,
                    "bestRating": 10,
                    "worstRating": 0
                },
                "author": {
                    "@type": "Person",
                    "name": appName
                },
                "reviewBody": this.$t('front.game.json_ld.review_body', {
                    gameTitle: this.game.title,
                    gamePlatform: this.game.platformTitle,
                })
            };
        },

        logotypePath() {
            return `/public/${brandName}/logotype/logo-mini.svg`;
        },

        appName() {
            return appName;
        },

        user() {
            return this.$store.state.user;
        },

        locale() {
            return this.$store.state.locale;
        },

        pageData(){
            return this.$store.getters.getPageData(this.$route);
        },

        page() {
            return this.pageData && this.pageData.page;
        },

        game() {
            return this.pageData && this.pageData.game;
        },

        createdAt() {
            return this.game.createdAt;
        },

        updatedAt() {
            return this.game.updatedAt;
        },

        backgroundImage() {
            return this.game.pageBackgroundImage && this.game.pageBackgroundImage.jpg || '';
        },

        gamePlayRealUrl() {
            return gamePlayRealUrl(this.$router, this.game, this.locale);
        },

        isPlayForFunAllowed(){
            return canPlayFun(this.game, this.user);
        },

        gamePlayFunUrl() {
            return gamePlayFunUrl(this.$router, this.game, this.locale);
        },
    },

    methods: {
        playForFun() {
            launchGameForFun(this, this.game);
        },

        playForReal() {
            launchGameForReal(this, this.game);
        },

        swiperNext() {
            this.$refs.swiperSS.$swiper.slideNext()
        },

        swiperPrev() {
            this.$refs.swiperSS.$swiper.slidePrev()

        },

        getRelatedGames() {
            return new Promise(resolve => {
                fetchLobbyRecommendedGames(this.createApiData({
                    gameId: this.game && this.game.id,
                    count: 10,
                }))
                    .then(relatedGames => {
                        this.relatedGames = relatedGames;
                        resolve();
                    })
                    .catch(() => resolve());
            });
        },
    },
}
</script>

<style lang="sass" scoped>
@import "sass/components/pages/parts/target/GameItemContent"
</style>